import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listForMe = async (
  companyId: string,
  companyType: string,
  filters: { unread_only?: boolean; page?: number; limit?: number } = {}
) =>
  post("projectService/notification/listForMe", {
    company_id: companyId,
    company_type: companyType,
    ...filters,
  });

export const markRead = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/notification/markRead", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const markAllRead = async (
  companyId: string,
  companyType: string
) =>
  post("projectService/notification/markAllRead", {
    company_id: companyId,
    company_type: companyType,
  });
